import { QueryErrorResetBoundary } from "@tanstack/react-query";
import RouterLoadingScreen from "components/loading-screen";
import ErrorBoundaryPage from "pages/errors/ErrorBoundaryPage";
import { ElementType, lazy, Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

// ----------------------------------------------------------------------
const Loadable = (Component: ElementType) => (props: any) =>
  (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onReset={reset}
          fallbackRender={({ resetErrorBoundary, error }) => (
            <ErrorBoundaryPage error={error} onClicked={() => resetErrorBoundary()} />
          )}
        >
          <Suspense fallback={<RouterLoadingScreen />}>
            <Component />
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );

export const LoadableLoginPage = Loadable(lazy(() => import("pages/login/LoginPage")));
export const LoadableLogoutPage = Loadable(lazy(() => import("pages/login/LogoutPage")));

// Errors
export const LoadableError401Page = lazy(() => import("pages/errors/Error401Page"));
export const LoadableError403Page = lazy(() => import("pages/errors/Error403Page"));
export const LoadableError404Page = lazy(() => import("pages/errors/Error404Page"));
export const LoadableError500Page = lazy(() => import("pages/errors/Error500Page"));

// Contact Us
export const LoadableContactUsPage = Loadable(lazy(() => import("pages/contact-us/ContactUsPage")));
export const LoadableContactUsDetailsPage = Loadable(
  lazy(() => import("pages/contact-us/ContactDetailsPage"))
);

// Layout
export const LoadableDefaultLayoutPage = Loadable(
  lazy(() => import("layouts/auth/DefaultLayout"))
);

// Fact Manager
export const LoadableFactManagerListPage = Loadable(lazy(() => import("pages/fact-manager/FactManagerListPage")));
export const LoadableFactManagerPage = Loadable(lazy(() => import("pages/fact-manager/FactManagerPage")));

// Organizations
export const LoadableOrganizationsListPage = Loadable(lazy(() => import("pages/organizations/OrganizationListPage")));
export const LoadableOrganizationPage = Loadable(lazy(() => import("pages/organizations/OrganizationPage")));

// Account Settings
export const LoadableAccountSettingsPage = Loadable(
  lazy(() => import("pages/account-settings/AccountSettingsPage"))
);
